import { reaction } from "mobx";
import { useEffect, useMemo } from "react";
import { LOCAL_STORAGE_JWT_TOKEN_NAME } from "../shortcode/account";
import { useStores } from "../store";
import { persistJwtToken } from "../utils";

/**
 * When the session JWT got renewed let's persist back to localStorage.
 */
function useAccountRenewedHookPersist() {
  const {
    accountStore: {
      session
    }
  } = useStores();

  // Listen to JWT changes in active session
  const dispatchJwtListener = useMemo(() => reaction(() => session === null || session === void 0 ? void 0 : session.jwt, value => {
    persistJwtToken(LOCAL_STORAGE_JWT_TOKEN_NAME, value);
  }), [session]);
  useEffect(() => dispatchJwtListener, [session]);
}
export { useAccountRenewedHookPersist };